import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import apontamentoReport from "./reports";
import ReportSummary from "./reports/summary";

export default class TTP extends Indicador {
    static get fullName() {
        return "Tamanho dos Toletes Picados";
    }

    static get abbrev() {
        return "TTP";
    }

    static get legacyApontamentoMap() {
        return {
            // Data/Hora de PS está realmente como 'dataHoraNGV' no banco.
            dataHoraVCC: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",


            insumo: "insumo",
            variedade: "variedade",
            georeferencia: "georeferencia",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    profundidadeSulcaçãoColeta: "profundidade",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",


            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            MetaTamanhoToletesPicadosManual: "manual.meta",
            MetaTamanhoToletesPicadosMecanizado: "mecanizado.meta",
            classificacaoTTP: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacao: "classificacao",
                    intervaloMinimo: "intervaloMin",
                    intervaloMaximo: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                    operador: "operador",
                    intervaloMinimo2: "intervaloMin2",
                    intervaloMaximo2: "intervaloMax2",
                    sinalIntervaloMin2: "sinalIntervaloMin2",
                    sinalIntervaloMax2: "sinalIntervaloMax2",

                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params, setApontamento) {
        const f = parseFloat

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0
        }

        // é um apontamento antigo?
        if (apontamento.coletas && apontamento.coletas.length > 0 && apontamento.coletas.filter(c => c.quantidade).length > 0) {
            const ehBom = (p) => {
                if (p.classificacao.toUpperCase().trim() === "BOM") {
                    return true
                }
                return false
            }

            let conformidade = 0
            let qtBOM = 0
            let qtTotal = 0

            // quantos são classificação "BOM" e a soma do total de todas classificações
            apontamento.coletas.forEach(p => {
                if (!isNaN(p.quantidade)) {
                    if (typeof p.quantidade === 'string' && p.quantidade.length === 0) {
                        p.quantidade = 0
                    }

                    if (ehBom(p)) {
                        qtBOM = f(p.quantidade)
                    }
                    qtTotal += f(p.quantidade)
                }
            })

            if (qtTotal) {
                conformidade = (qtBOM / qtTotal * 100).toFixed(2)
            }

            // percentual de cada classificação
            apontamento.coletas.forEach(p => {
                if (p.quantidade && qtTotal) {

                    p.percentual = (f(p.quantidade) / qtTotal * 100).toFixed(2)
                } else {
                    p.percentual = 0
                }
            })
            apontamento.conformidade = conformidade
            apontamento.totalToletes = qtTotal


            setApontamento(apontamento)

            return conformidade
        } else {
            let conformeCount = 0
            const total = apontamento.coletas.length
            apontamento.totalToletes = total

            for (const coleta of apontamento.coletas) {
                if (f(coleta.tolete) >= f(params.intervaloMin) && f(coleta.tolete) <= f(params.intervaloMax)) {
                    coleta.conforme = "Sim"
                    coleta.acima = 0
                    coleta.abaixo = 0
                    conformeCount++
                } else {
                    coleta.conforme = "Não"
                    if (f(coleta.tolete) > f(params.intervaloMax)) {
                        coleta.acima = 1
                        coleta.abaixo = 0
                    } else {
                        coleta.acima = 0
                        coleta.abaixo = 1
                    }
                }
            }

            return ((100 * conformeCount) / total).toFixed(2)
        }
    }

    logicaOldTch(atualValues, propsG, value) {
        // aderencia = (valorcoleta/totalcoletas )*100 --- vou ter o % da aderência é validado o campo Bom, tem que ser de acordo com a Meta (%)
        let valorComparar = 0;
        let conformidade = 0;
        if (atualValues.classificacaoBom && atualValues.classificacaoBom.indexOf('Bom') !== -1) {
            valorComparar = atualValues.qtdToleteBom;
        }
        if (atualValues.classificacaoRegular && atualValues.classificacaoRegular.indexOf('Bom') !== -1) {
            valorComparar = atualValues.qtdToleteRegular;
        }
        if (atualValues.classificacaoRuim && atualValues.classificacaoRuim.indexOf('Bom') !== -1) {
            valorComparar = atualValues.qtdToleteRuim;
        }
        if (atualValues.totalQtdToletes && atualValues.totalQtdToletes !== 0) {
            // conformidade = parseFloat(valorComparar)/parseFloat(atualValues.totalQtdToletes)
            // conformidade = (conformidade*100).toFixed(2);
            let porcentagem = ((parseFloat(valorComparar) / parseFloat(atualValues.totalQtdToletes)) * 100).toFixed(2)

            conformidade = porcentagem > 100 ? porcentagem - 200 : porcentagem;

            if (conformidade < 0) {
                conformidade = conformidade * (-1);
            }
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.2, 100, 104.3);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.tolete)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },

            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },
            { title: "Insumo", field: "insumo.nomeInsumo", width: 'auto' },
            { title: "Variedade", field: "variedade.nomeInsumo", width: 'auto' },

            { title: "Total Toletes", field: "totalToletes", width: 'auto' },

            {
                title: "Conf.(%) ", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Total Toletes: " + apontamento.totalToletes
    }
}
